module.exports = __webpack_public_path__ + "static/media/logo.4a9301ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo.png
// module id = 82
// module chunks = 0